import React from "react";
import {categoryPromotionService} from "../jwt/_services/promotions/categoryPromotionService";

export const categoryPromotionProvider = {
    getOptions,
    getItem,
};

async function getOptions(fbDataBaseId = null) {
    try {
        const listItems = await categoryPromotionService.search(0,100, {
            fbDataBase : {  id : fbDataBaseId },
            item : { code: null, }
        } );

        return listItems.data.map((itemData) => {
            return (
                {
                    id: itemData.id,
                    value: itemData.code,
                    label: <div><label>{itemData.code + ' - ' + itemData.description}</label></div>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

async function getItem(id) {
    try {
        const item = await categoryPromotionService.getItem(id);
        let show = item.code != null && item.code !== "" ? item.code + " - " + item.description : item.description;
        return (
            {
                id: item.id,
                value: show,
                label: <div><label>{show}</label></div>
            }
        );
    } catch (error) {
        console.log(error.message)
    }
}